import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Message, Icon, Button, List } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './LicenseDelete.css';
const cx = classNames.bind(styles);

class LicenseDelete extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { deleting, isAuth, inTableMenu, licenseInfo, removeLicense, handleOnToggleDeleteModal } = this.props;
    const {
      licenseNo,
      serviceName,
      startEpoch,
      endEpoch,
      licenseCount,
      licenseUnit,
      orderUserName,
      orderUserEmail,
      examUsedCount,
      examLimitCount,
      licenseType,
      regEpoch
    } = licenseInfo;

    let licenseTypeText = '';
    if (licenseType === 1) {
      licenseTypeText = defineMessages(formatMessage({ id: 'LicenseEdit_24', defaultMessage: '영구 라이센스' }));
    } else if (licenseType === 2) {
      licenseTypeText = defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' }));
    } else if (licenseType === 4) {
      licenseTypeText = defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' }));
    }

    const actionMode =
      inTableMenu && isAuth === 2
        ? defineMessages(formatMessage({ id: 'LicenseDelete_1', defaultMessage: '삭제' }))
        : defineMessages(formatMessage({ id: 'LicenseDelete_2', defaultMessage: '신청 취소' }));

    const actionMode2 =
      inTableMenu && isAuth === 2
        ? defineMessages(formatMessage({ id: 'LicenseDelete_19', defaultMessage: '삭제' }))
        : defineMessages(formatMessage({ id: 'LicenseDelete_2', defaultMessage: '신청 취소' }));

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'common-content')}
        closeIcon
        onToggleModal={handleOnToggleDeleteModal}
        visible
        header={
          <div>
            {defineMessages(
              formatMessage({
                id: 'LicenseDelete_3',
                defaultMessage: '라이센스'
              })
            ) +
              ' ' +
              actionMode}
          </div>
        }
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleDeleteModal}>
              {defineMessages(
                formatMessage({
                  id: 'LicenseDelete_4',
                  defaultMessage: '닫 기'
                })
              )}
            </Btn>
            <Btn className={cx('gray-button')} loading={deleting} disabled={deleting} onClick={removeLicense}>
              {defineMessages(
                formatMessage({
                  id: 'LicenseDelete_17',
                  defaultMessage: '신청 취소'
                })
              )}
            </Btn>
          </div>
        }>
        <Loading
          active={deleting}
          size="small"
          content={defineMessages(
            formatMessage({
              id: 'LicenseDelete_5',
              defaultMessage: '삭제중...'
            })
          )}
        />
        <div className={cx('message-header')}>
          <div>
            {defineMessages(
              formatMessage({
                id: 'LicenseDelete_18',
                defaultMessage: '다음 라이센스를 '
              })
            ) +
              actionMode2 +
              defineMessages(
                formatMessage({
                  id: 'LicenseDelete_14',
                  defaultMessage: '합니까?'
                })
              ) +
              defineMessages(formatMessage({ id: 'LicenseDelete_15', defaultMessage: ' ' })) +
              defineMessages(formatMessage({ id: 'LicenseDelete_16', defaultMessage: ' ' }))}
          </div>
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            {/* <div className={cx('template-detail-name')}>세부정보</div> */}
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>No</div>
                {licenseNo}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(
                    formatMessage({
                      id: 'LicenseDelete_7',
                      defaultMessage: '서비스'
                    })
                  )}
                </div>
                {serviceName}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(
                    formatMessage({
                      id: 'LicenseEdit_23',
                      defaultMessage: '라이센스 타입'
                    })
                  )}
                </div>
                {licenseTypeText}
              </List.Item>
              {licenseType === 2 && (
                <List.Item className={cx('template-detail-item')}>
                  <div className={cx('template-detail-item-title')}>
                    {defineMessages(
                      formatMessage({
                        id: 'LicenseDelete_8',
                        defaultMessage: '유효기간'
                      })
                    )}
                  </div>
                  {common.timeFormatFromUTCEpoch(startEpoch, 3) + ' ~ ' + common.timeFormatFromUTCEpoch(endEpoch, 3)}
                </List.Item>
              )}
              {licenseType === 4 && (
                <List.Item className={cx('template-detail-item')}>
                  <div className={cx('template-detail-item-title')}>
                    {defineMessages(
                      formatMessage({
                        id: 'LicenseEdit_30',
                        defaultMessage: '훈련 횟수'
                      })
                    )}
                  </div>
                  {examUsedCount +
                    ' / ' +
                    examLimitCount +
                    defineMessages(
                      formatMessage({
                        id: 'TargetDetail_32',
                        defaultMessage: '회'
                      })
                    )}
                </List.Item>
              )}
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(
                    formatMessage({
                      id: 'LicenseDelete_10',
                      defaultMessage: '수량'
                    })
                  )}
                </div>
                {common.commaNumber(licenseCount) +
                  defineMessages(
                    formatMessage({
                      id: 'LicenseDelete_11',
                      defaultMessage: '명'
                    })
                  )}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(
                    formatMessage({
                      id: 'LicenseDelete_12',
                      defaultMessage: '신청인'
                    })
                  )}
                </div>
                {orderUserName + ' (' + orderUserEmail + ')'}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(
                    formatMessage({
                      id: 'LicenseDelete_13',
                      defaultMessage: '신청일시'
                    })
                  )}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

LicenseDelete.propTypes = {
  //
};
LicenseDelete.defaultProps = {
  //
};

export default injectIntl(LicenseDelete);



// WEBPACK FOOTER //
// ./src/script/components/license/LicenseDelete.js